module.exports = __webpack_public_path__ + "static/media/icon-spinner.526f7138.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-spinner.svg
// module id = 1238
// module chunks = 0